import * as React from 'react';

type PatientInviteControllerProps = {
  
};

export const usePatientInviteController = (props: PatientInviteControllerProps) => {
  const [patientInviteOpened, setPatientInviteOpened] = React.useState(false);

  const openPatientInvite = React.useCallback(() => {
    setPatientInviteOpened(true);
  }, []);

  const closePatientInvite = React.useCallback(() => {
    setPatientInviteOpened(false);
  }, []);

  return {
    patientInviteOpened,
    openPatientInvite,
    closePatientInvite,
  };
};